export const DEFAULT_CHANNELS_PER_PAGE = 3;
